<template>
  <div class="top-menu">
    <div>
	  <b-navbar toggleable="lg" type="dark" variant="info">
	    <b-navbar-brand to="/">ColLabOk</b-navbar-brand>
			<b-navbar-nav>
		        <b-nav-text>{{ title }}</b-nav-text>
		    </b-navbar-nav>
	    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

	    <b-collapse id="nav-collapse" is-nav>
	      <!-- Right aligned nav items -->
	      <b-navbar-nav class="ml-auto">
	        <b-nav-item-dropdown right v-if="loggedIn">
	          <!-- Using 'button-content' slot -->
	          <template slot="button-content"><em>{{ user.name }}</em></template>
	          <b-dropdown-item to="/profile">Profile</b-dropdown-item>
	          <b-dropdown-item to="/">Dashboard</b-dropdown-item>
	          <b-dropdown-item href="#" @click="$API.doLogout()">Sign Out</b-dropdown-item>
	        </b-nav-item-dropdown>
	      </b-navbar-nav>
	    </b-collapse>
	  </b-navbar>
	</div>

  </div>
</template>

<script>
export default {
  name: 'TopMenu',
  props: {
    items: Array,
    title: String,
    user: Object,
    loggedIn: Boolean
  }
}
</script>